import React from 'react';
import { FormattedMessage } from 'react-intl';
import GoogleCalendar from 'containers/GoogleCalendar/GoogleCalendarContainer';
import OutlookCalendar from 'containers/OutlookCalendar/OutlookCalendarContainer';
import classes from './SyncCalendar.module.scss';

const SyncCalendar = () => (
  <div className={classes.container}>
    <header>
      <h1>
        <FormattedMessage
          id="settings.syncCalendar.sync"
          defaultMessage="Connect your calendar to view upcoming Lifesize calls!"
        />
      </h1>
    </header>
    <div className={classes.settingsBody}>
      <GoogleCalendar bigButton dataTestTag='google-calendar' />
      <OutlookCalendar bigButton dataTestTag='outlook-calendar' />
    </div>
  </div>
);


export default SyncCalendar;
